import React, { SVGAttributes } from 'react'
import { useTranslation } from 'react-i18next'

const SvgLiveBadge = (props: SVGAttributes<SVGElement>): JSX.Element => {
  const [t] = useTranslation()

  return (
    <svg width={35} height={21} {...props}>
      <g fill="none" fillRule="evenodd">
        <rect width={35} height={21} fill="#4fbdf4" rx={2} />
        <text fill="#FFF" fontFamily="Lato-Bold, Lato" fontSize={12} fontWeight="bold" letterSpacing={0.5}>
          <tspan x={5.463} y={15}>
            {t('icons.liveBadge.text')}
          </tspan>
        </text>
      </g>
    </svg>
  )
}

export default SvgLiveBadge
